import { computed, ref, type CSSProperties } from "vue";

export type DashboardEntranceVariant = "rise" | "expand" | "drift" | "unblur";

const ENTRANCE_VARIANTS: readonly DashboardEntranceVariant[] = [
    "rise",
    "expand",
    "drift",
    "unblur",
] as const;

const STAGGER_STEP_MS = 70;

const pickEntranceVariant = (): DashboardEntranceVariant => {
    const index = Math.floor(Math.random() * ENTRANCE_VARIANTS.length);

    return ENTRANCE_VARIANTS[index] ?? "rise";
};

export const useDashboardEntrance = () => {
    const entranceVariant = ref<DashboardEntranceVariant>(
        pickEntranceVariant(),
    );

    const entranceClass = computed<string>(
        () => `dashboard-entrance dashboard-entrance--${entranceVariant.value}`,
    );

    const resolveEntranceDelay = (order: number): CSSProperties => ({
        animationDelay: `${order * STAGGER_STEP_MS}ms`,
    });

    return { entranceVariant, entranceClass, resolveEntranceDelay };
};
